const {account$} = require("../../../../emitters/account");
const {
  INTERVAL_DAY,
  INTERVAL_WEEK,
  INTERVAL_MONTH,
  INTERVAL_YEAR,
  INTERVAL_ALL_TIME,
  INTERVAL_CUSTOM
} = require("../constants/intervals");

function intervalHandleProvider(days) {
  return () => {
    const dateTo = new Date();
    dateTo.setHours(23, 59, 59, 0);

    const dateFrom = new Date();
    dateFrom.setDate(dateTo.getDate() - days);
    dateFrom.setHours(0, 0, 0, 0);
    return {
      from: dateFrom.getTime(),
      to: dateTo.getTime(),
    };
  };
}

const handleIntervalDay = intervalHandleProvider(1);
const handleIntervalWeek = intervalHandleProvider(7);
const handleIntervalMonth = intervalHandleProvider(30);
const handleIntervalYear = intervalHandleProvider(365);
const handleIntervalAllTime = () => {
  const acc = account$.getValue() || {onboarding_dt: '2010-01-01'};
  return ({
    from: new Date(acc.onboarding_dt).getTime(),
    to: new Date().getTime()
  })
};
const handleIntervalCustom = (filter) => ({
  from: filter.from,
  to: filter.to,
});
export const INTERVAL_HANDLES_MAP = {
  [INTERVAL_DAY]: handleIntervalDay,
  [INTERVAL_WEEK]: handleIntervalWeek,
  [INTERVAL_MONTH]: handleIntervalMonth,
  [INTERVAL_YEAR]: handleIntervalYear,
  [INTERVAL_ALL_TIME]: handleIntervalAllTime,
  [INTERVAL_CUSTOM]: handleIntervalCustom,
};

function getDateRange(filter) {
  filter = filter || {};
  const search = filter.search;
  const output = (
    INTERVAL_HANDLES_MAP[filter.interval] || handleIntervalCustom
  )(filter);
  search && (output.search = search);
  return output;
}

module.exports = getDateRange;
